"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M13.0003 1.999H11.012v2h1.9883v-2zM3.8396 16.7058l-.9955-1.7242 1.732-1 .9955 1.7242-1.732 1zm-1.3337-6.2617.3472-1.9697 1.9696.3472-.3472 1.9697-1.9696-.3472zm2.6714-5.8438 1.523-1.278 1.451 1.7291-1.523 1.278-1.451-1.729zM9.5002 19.999h5.0001v2H9.5002v-2z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5186 8.931c-.5967.5853-1.0183 1.4934-1.0183 2.7823 0 .8935.3911 1.7662.98 2.7713.121.2066.2547.4244.3937.6509.356.5803.7466 1.2169 1.047 1.8635h2.1474c.3028-.6708.7074-1.3274 1.0736-1.9216a40.142 40.142 0 0 0 .3629-.5965c.5974-1.0099.9954-1.8792.9954-2.7676 0-1.2889-.4216-2.197-1.0183-2.7824-.6028-.5913-1.4644-.9319-2.4817-.9319s-1.8789.3406-2.4817.932zM8.118 7.5031c1.026-1.0063 2.4143-1.5041 3.8823-1.5041s2.8564.4978 3.8823 1.5042c1.0319 1.0124 1.6177 2.4614 1.6177 4.2101 0 1.4687-.6567 2.7423-1.2741 3.7859-.1601.2707-.3151.5233-.4619.7627-.4672.7614-.8526 1.3896-1.0617 2.0422l-.2226.6949H9.5366l-.232-.6749c-.2218-.6454-.5987-1.2613-1.048-1.9957a49.413 49.413 0 0 1-.502-.8328c-.6142-1.0484-1.2543-2.3186-1.2543-3.7823 0-1.7487.5858-3.1977 1.6177-4.21z"
  }), _react.default.createElement("path", {
    d: "m20.161 16.7058.9955-1.7242-1.732-1-.9955 1.7242 1.732 1zm1.3337-6.2617-.3472-1.9697-1.9697.3472.3473 1.9697 1.9696-.3472zm-2.6714-5.8438-1.523-1.278-1.451 1.7291 1.523 1.278 1.451-1.729z"
  })];
};

exports.default = _default;